// extracted by mini-css-extract-plugin
export default {"entityLink":"WorkLogAssignmentInfo_entityLink__Zzhqz"};